import config from './config'
import Create from './create'
import Edit from './edit'
import List from './list'
import Show from './show'

export default {
  ...config,
  config,
  list: List,
  show: Show,
  edit: Edit,
  create: Create,
}
